export default {
  isDesignShared: (state) => (designId) => {
    return state.sharedDesigns.find((d) => d.DesignId === designId);
  },
};
